<template>
  <div style="width: 100%; height: 100%;">
    <Echart
      :options="options"
      id="TypeLine"
      height="100%"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
export default {
  data () {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler (newData) {
        this.options = {
          tooltip: {
            trigger: 'item'
          },
          color: ['#f7b851', '#3f96db', '#ab99fc'],
          series: [
            {
              type: "pie",
              radius: ['45%', '70%'],
              clickable:false,　　　　　　 //是否开启点击
              minAngle: 5,           　　 //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
              avoidLabelOverlap: false,
              center: ['50%', '50%'],
              itemStyle: {
                borderRadius: 5,
                borderColor: '#fff',
                borderWidth: 2,

              },

              labelLine: {
                show: false
              },
              data: newData.weekLineData,
              itemStyle: {
                normal: {
                  label: {        //此处为指示线文字
                    show: true,
                    position: 'inner', //标签的位置
                    textStyle: {
                      fontWeight: 500,
                      color: '#FFFFFF',
                      fontSize: 12    //文字的字体大小
                    },
                    formatter: '{c}%' //指示线对应文字
                  },
                  borderRadius: 6,
                  borderColor: '#fff',
                  borderWidth: 2,
                }
              },
            }
          ]
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/echart/TypePie/chart.vue